export enum ApprovalProcessingSource {
  SYSTEM = 1,
  MANUAL = 2
}
